import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from '../api/axios';
import { Apitoken, Authtoken } from '../Global';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
 
const EditCabraneModel = ({ itemId, handleClose, show }) => {
  // const [showCategory, setShowCategory] = useState(false);
  const [formData, setFormData] = useState({});
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState([]);
  console.log("Modal show prop add:", show);
  // const [permission, setPermission] = useState({});

  useEffect(() => {
//         setPermission(FindModuleById(251)); 
// console.log(permission);

    if (itemId) {
      axios
        .get(`/rawmaterials-cabranes/edit/${itemId}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            setFormData(response.data.data.cabrane);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [itemId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    delete backendErrors[name];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post('/rawmaterials-cabranes/update', formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = '/rawmaterials-cabranes';
          }, 500);
        } else {
          setBackendErrors(response.data.error);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header>
        <h4 className="modal-title">Edit Cabrane</h4>
        <button type="button" className="close" onClick={handleClose} aria-hidden="true">
          &times;
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {backendSuccess && <div className="from-success mt-1">{backendSuccess}</div>}

          <div className="form-group">
            <label>Name</label>
            <input
              className="form-control form-white"
              placeholder=" Name"
              type="text"
              name="name"
              value={formData.name || ''}
              onChange={handleChange}
            />
            {backendErrors.name && <small className="form-error mt-1">{backendErrors.name}</small>}
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              className="form-control form-white"
              placeholder="Phone Number"
              type="text"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={handleChange}
            />
            {backendErrors.phone_number && (
              <small className="form-error mt-1">{backendErrors.phone_number}</small>
            )}
          </div>

          <div className="form-group">
            <label>Note:</label>
            <textarea
              className="form-control form-white"
              placeholder="Enter Note"
              name="note"
              value={formData.note || ''}
              onChange={handleChange}
            ></textarea>
            {backendErrors.note && <small className="form-error mt-1">{backendErrors.note}</small>}
          </div>

          <div className="submit-section">
            <button type="submit" className="btn btn-primary save-category submit-btn">
              UPDATE
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

EditCabraneModel.propTypes = {
  itemId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default EditCabraneModel;
